<div class="container-fluid bg-fondo p-5">
    <div class="justify-content-center">
      <p>Te invitamos a continuar con el proceso y seguir avanzando hacia tus sueños.</p>
      <p><strong>¿Deseas continuar con el proceso de adjudicación?</strong></p>
      <div class="button-position">
        <button class="btn response_no font-weight-bold" (click)="cancelProcess()">
            No
        </button>
        <button class="btn response_yes font-weight-bold" (click) = "next()">
            Si
        </button>
      </div>
      <br>
      <div class="button-position">
        <button type="button" class="btn btn-primary font-weight-bold m-2" title="Volver" (click)="onBack()">
          <i class="fas fa-arrow-left"></i>
          Volver
        </button>   
      </div>
    </div>
</div>

<ngx-spinner color="#c2af85" size="medium" type="ball-fussion">
  <p class='color-spinner-text'>Cargando... </p>
</ngx-spinner>

